module.exports = __webpack_public_path__ + "img/header.70859e0c.png";